<template>
  <div class="loading-bar">
    <div>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
  .loading-bar {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.1);
    min-height: 100vh;
    display: flex;
    align-items: center;

    div {
      margin: 0 auto;
      color: whitesmoke;

      .spinner {
        width: 50px;
        height: 50px;
        margin: 0 auto;
        border-top: 9px solid rgba(0, 0, 0, 0.2);
        border-right: 9px solid rgba(0, 0, 0, 0.2);
        border-bottom: 9px solid rgba(0, 0, 0, 0.2);
        border-left: 9px solid #6E1B56;
        border-radius: 50%;
        animation: load 1.1s infinite linear;
      }
    }
  }

  @keyframes load {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>
